;globalThis["_sentryRewritesTunnelPath"] = "/monitoring";globalThis["SENTRY_RELEASE"] = {"id":"1792691009650"};globalThis["_sentryBasePath"] = undefined;globalThis["_sentryRewriteFramesAssetPrefixPath"] = "";import { init, replayIntegration } from '@sentry/nextjs';

init({
	dsn: process.env.NEXT_PUBLIC_SENTRY_DSN,
	debug: false,
	replaysOnErrorSampleRate: 1.0,
	tracesSampleRate: 0,
	replaysSessionSampleRate: 0,
	integrations: [
		replayIntegration({
			maskAllText: false,
			maskAllInputs: false,
			blockAllMedia: false,
		}),
	],
	environment: process.env.NEXT_PUBLIC_SENTRY_ENV,
});
